var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { loginApi } from 'apis/login';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAuthMagicLink, } from './utils/useAuthMagicLink/useAuthMagicLink';
import { useAuthOktaClient, } from './utils/useAuthOktaClient/useAuthOktaClient';
/**
 * A hook that resolves the auth data from the dixa login page or the okta
 * client depending on what the auth method endpoint returns from the login
 * api.
 *
 * While we can check for presence of the magic link search params, we have to
 * explicitly query the auth method endpoint for the login method to rule out
 * that there is no okta login method present as well. The backend thus decides
 * the type of login regardless of potentially present search params.
 */
export const useAuthMethod = () => {
    const dispatch = useAppDispatch();
    const getAuthDataFromMagicLink = useAuthMagicLink();
    const getAuthDataFromOktaClient = useAuthOktaClient();
    /** Gets the auth data through the magic link or okta client. */
    const trigger = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield dispatch(loginApi.endpoints.readAuthMethod.initiate());
        if ((data === null || data === void 0 ? void 0 : data.data.auth_method.type) === 'dixa_magic_link') {
            return getAuthDataFromMagicLink();
        }
        if ((data === null || data === void 0 ? void 0 : data.data.auth_method.type) === 'okta_openid_connect') {
            return getAuthDataFromOktaClient(data.data.auth_method);
        }
        return Promise.reject();
    }), [dispatch, getAuthDataFromMagicLink, getAuthDataFromOktaClient]);
    return trigger;
};
